<template>
    <div class="modal-box-warning">
        <p class="modal-box-warning-title">
            {{ t({ key: 'shared.discard_changes' }) }}
        </p>
        <p class="modal-box-warning-description">
            {{ t({ key: 'shared.choices_you_made_will_be_lost' }) }}
        </p>
        <div class="modal-box-warning-buttons">
            <ButtonPrimary :onClick="onAccept">
                {{ t({ key: 'shared.yes_discard' }) }}
            </ButtonPrimary>
            <ButtonSecondary :onClick="onDeny">
                {{ t({ key: 'shared.no_take_me_back' }) }}
            </ButtonSecondary>
        </div>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent } from 'vue';
    import ButtonPrimary from '@ui/components/Button/ButtonPrimary.vue';
    import ButtonSecondary from '@ui/components/Button/ButtonSecondary.vue';

    export default defineComponent({
        name: 'Warning',
        components: { ButtonPrimary, ButtonSecondary },
        methods: { t },
        props: {
            onAccept: Function,
            onDeny: Function,
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Warning.scss';
</style>
